import { CalendarIcon } from "@heroicons/react/solid";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactSlotTitle from "../CompactSlotTitle";
import { Popover } from "@headlessui/react";

export default function CompactScheduleSlot({
  slot,
  onClick,
  setOpen,
}: {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
  setOpen?: () => void;
}) {
  return (
    <button
      role="button"
      onClick={!!setOpen ? setOpen : () => {}}
      className="w-full px-1  py-0.5 h-full  rounded-md bg-white"
    >
      <div className="hover:bg-gray-50 border border-gray-300 w-full h-full rounded-md bg-white px-2 py-1 opacity-60">
        <p className="text-gray-700 text-xs leading-5 font-normal flex items-center justify-between truncate">
          <CompactSlotTitle slot={slot} />
          <CalendarIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </p>
      </div>
    </button>
  );
}
